// Dummy dashboard content for every PropertyPro sidebar category other than
// "Property Transactions" (which is backed by real aggregated data via dataService.js).
// Each entry drives the generic <CategoryDashboard /> renderer: a few KPI stat
// cards, one chart, and a short narrative insight.

const categoryData = {
  'Market Demographics & Economics': {
    kpis: [
      { label: 'Catchment Population', value: '182,400', delta: '+4.2%', tone: 'up' },
      { label: 'Median Household Income', value: '$9,850/mo', delta: '+2.1%', tone: 'up' },
      { label: 'Avg. Resident Age', value: '34.6 yrs', delta: 'flat', tone: 'flat' },
    ],
    chart: {
      type: 'bar',
      title: 'Median Household Income by Project Catchment',
      data: [
        { name: 'Marina Bay Residences', value: 11200 },
        { name: 'Orchard Heights', value: 12500 },
        { name: 'River Valley Tower', value: 9800 },
        { name: 'Tampines Central Mall', value: 8200 },
        { name: 'Sentosa Cove Villas', value: 15400 },
      ],
      series: [{ dataKey: 'value', name: 'Median Income ($)', color: '#7C3AED' }],
      xKey: 'name',
    },
    insight: "Sentosa Cove Villas' catchment shows the highest household income, supporting premium positioning; Tampines Central Mall's younger, higher-density catchment favours mid-market retail.",
  },

  'Zoning & Land Use': {
    kpis: [
      { label: 'Total GFA Approved', value: '1.85M sqft', delta: '+0.3M', tone: 'up' },
      { label: 'Avg. Plot Ratio', value: '3.2', delta: 'flat', tone: 'flat' },
      { label: 'Sites Under URA Review', value: '4', delta: '+1', tone: 'up' },
    ],
    chart: {
      type: 'pie',
      title: 'Portfolio Land Use Mix',
      data: [
        { name: 'Residential', value: 55 },
        { name: 'Commercial', value: 20 },
        { name: 'Mixed-Use', value: 15 },
        { name: 'Civic / Green', value: 10 },
      ],
    },
    insight: 'Residential remains the dominant zoning allocation across the portfolio; two sites are pending URA plot ratio review for uplift potential.',
  },

  'Environmental / Site': {
    kpis: [
      { label: 'Sites with EIA Cleared', value: '4 / 5', delta: '', tone: 'flat' },
      { label: 'Avg. Soil Contamination Risk', value: 'Low', delta: '', tone: 'flat' },
      { label: 'Sites in Flood Risk Zone', value: '1', delta: '', tone: 'down' },
    ],
    chart: {
      type: 'bar',
      title: 'Environmental Risk Score by Project (0–100, lower is better)',
      data: [
        { name: 'Marina Bay Residences', value: 18 },
        { name: 'Orchard Heights', value: 12 },
        { name: 'River Valley Tower', value: 34 },
        { name: 'Tampines Central Mall', value: 22 },
        { name: 'Sentosa Cove Villas', value: 9 },
      ],
      series: [{ dataKey: 'value', name: 'Risk Score', color: '#F97316' }],
      xKey: 'name',
    },
    insight: 'River Valley Tower carries the highest environmental risk score due to proximity to the flood-prone river basin — recommend an additional drainage mitigation study.',
  },

  'Architecture & BIM': {
    kpis: [
      { label: 'BIM Models Coordinated', value: '5 / 5', delta: '', tone: 'flat' },
      { label: 'Clash Detections Resolved', value: '342 / 360', delta: '95%', tone: 'up' },
      { label: 'Avg. LOD Achieved', value: '350', delta: '', tone: 'flat' },
    ],
    chart: {
      type: 'bar',
      title: 'Clash Detections by Discipline',
      data: [
        { name: 'Structural', value: 45 },
        { name: 'MEP', value: 210 },
        { name: 'Architectural', value: 60 },
        { name: 'Civil', value: 45 },
      ],
      series: [{ dataKey: 'value', name: 'Clashes', color: '#06B6D4' }],
      xKey: 'name',
    },
    insight: 'MEP clashes account for 58% of all detections — recommend earlier MEP coordination workshops in the next design phase.',
  },

  'Site / Massing Optimization': {
    kpis: [
      { label: 'Design Iterations Generated', value: '128', delta: '', tone: 'flat' },
      { label: 'Best GFA Yield', value: '94.2%', delta: '+16pts', tone: 'up' },
      { label: 'Avg. Daylight Factor', value: '2.1%', delta: '', tone: 'flat' },
    ],
    chart: {
      type: 'line',
      title: 'GFA Yield % Across Optimization Batches',
      data: [
        { name: 'Batch 1', value: 78 },
        { name: 'Batch 2', value: 84 },
        { name: 'Batch 3', value: 88 },
        { name: 'Batch 4', value: 90 },
        { name: 'Batch 5', value: 92 },
        { name: 'Batch 6', value: 94.2 },
      ],
      series: [{ dataKey: 'value', name: 'GFA Yield %', color: '#7C3AED' }],
      xKey: 'name',
    },
    insight: 'Generative design converged on a 94.2% GFA yield after 6 optimization batches, a 16-point improvement over the manual baseline massing.',
  },

  'Cost Estimation': {
    kpis: [
      { label: 'Total Estimated Cost', value: '$412M', delta: '', tone: 'flat' },
      { label: 'Cost per sqft', value: '$612', delta: '', tone: 'flat' },
      { label: 'Contingency Held', value: '8.5%', delta: '', tone: 'flat' },
    ],
    chart: {
      type: 'bar',
      title: 'Cost Breakdown by Category',
      data: [
        { name: 'Structure', value: 38 },
        { name: 'MEP', value: 22 },
        { name: 'Finishes', value: 18 },
        { name: 'Facade', value: 12 },
        { name: 'Site Works', value: 10 },
      ],
      series: [{ dataKey: 'value', name: '% of Budget', color: '#22C55E' }],
      xKey: 'name',
    },
    insight: 'Facade costs are trending 6% above benchmark due to the premium glazing spec on Sentosa Cove Villas — flagged for value engineering review.',
  },

  'Sustainability / Energy': {
    kpis: [
      { label: 'Target Green Mark Rating', value: 'Platinum', delta: '', tone: 'flat' },
      { label: 'Est. Energy Use Intensity', value: '98 kWh/m²/yr', delta: '-32%', tone: 'up' },
      { label: 'Renewable Energy Offset', value: '22%', delta: '', tone: 'flat' },
    ],
    chart: {
      type: 'line',
      title: 'Projected EUI Reduction Across Design Revisions',
      data: [
        { name: 'v1', value: 145 },
        { name: 'v2', value: 128 },
        { name: 'v3', value: 116 },
        { name: 'v4', value: 105 },
        { name: 'v5', value: 98 },
      ],
      series: [{ dataKey: 'value', name: 'EUI (kWh/m²/yr)', color: '#F97316' }],
      xKey: 'name',
    },
    insight: 'Design revisions have cut projected energy use intensity by 32% since v1 — on track to meet the Green Mark Platinum threshold of under 100 kWh/m²/yr.',
  },

  'Project Management': {
    kpis: [
      { label: 'Active Projects', value: '5', delta: '', tone: 'flat' },
      { label: 'Projects On Schedule', value: '4 / 5', delta: '', tone: 'flat' },
      { label: 'Open RFIs', value: '27', delta: '+6', tone: 'down' },
    ],
    chart: {
      type: 'bar',
      title: 'Milestone Completion % by Project',
      data: [
        { name: 'Marina Bay Residences', value: 82 },
        { name: 'Orchard Heights', value: 65 },
        { name: 'River Valley Tower', value: 48 },
        { name: 'Tampines Central Mall', value: 91 },
        { name: 'Sentosa Cove Villas', value: 33 },
      ],
      series: [{ dataKey: 'value', name: 'Completion %', color: '#7C3AED' }],
      xKey: 'name',
    },
    insight: "River Valley Tower is 9 points behind its planned milestone curve, primarily due to piling delays — recommend a schedule recovery plan.",
  },

  Scheduling: {
    kpis: [
      { label: 'Critical Path Slack', value: '3 days', delta: '', tone: 'flat' },
      { label: 'Weather Delay Days (YTD)', value: '12', delta: '', tone: 'down' },
      { label: 'Forecast Completion', value: 'Q3 2026', delta: '', tone: 'flat' },
    ],
    chart: {
      type: 'line',
      title: 'Planned vs Actual Progress %',
      data: [
        { name: 'M1', planned: 10, actual: 8 },
        { name: 'M2', planned: 22, actual: 19 },
        { name: 'M3', planned: 35, actual: 30 },
        { name: 'M4', planned: 48, actual: 41 },
        { name: 'M5', planned: 60, actual: 52 },
        { name: 'M6', planned: 72, actual: 63 },
        { name: 'M7', planned: 85, actual: 74 },
        { name: 'M8', planned: 95, actual: 84 },
      ],
      series: [
        { dataKey: 'planned', name: 'Planned %', color: '#9CA3AF' },
        { dataKey: 'actual', name: 'Actual %', color: '#7C3AED' },
      ],
      xKey: 'name',
    },
    insight: 'Actual progress has tracked roughly 10 points behind plan since month 4 — cumulative slippage driven mainly by weather delays and rebar supply lead times.',
  },

  'Progress Capture': {
    kpis: [
      { label: 'Sites with Drone Capture', value: '5 / 5', delta: '', tone: 'flat' },
      { label: 'Photos Logged (30d)', value: '1,240', delta: '+18%', tone: 'up' },
      { label: 'AI-Flagged Issues', value: '18', delta: '', tone: 'flat' },
    ],
    chart: {
      type: 'line',
      title: 'Weekly Progress Photo Volume',
      data: [
        { name: 'Wk 1', value: 120 },
        { name: 'Wk 2', value: 145 },
        { name: 'Wk 3', value: 138 },
        { name: 'Wk 4', value: 160 },
        { name: 'Wk 5', value: 175 },
        { name: 'Wk 6', value: 190 },
        { name: 'Wk 7', value: 205 },
        { name: 'Wk 8', value: 210 },
      ],
      series: [{ dataKey: 'value', name: 'Photos Logged', color: '#06B6D4' }],
      xKey: 'name',
    },
    insight: 'AI-flagged issues are concentrated in facade installation (11 of 18) — auto-routed to the QA team for site verification.',
  },

  'Procurement / Supply Chain': {
    kpis: [
      { label: 'POs Issued (90d)', value: '86', delta: '', tone: 'flat' },
      { label: 'On-Time Delivery', value: '91%', delta: '+3pts', tone: 'up' },
      { label: 'Avg. Lead Time', value: '6.4 wks', delta: '+1.2wk', tone: 'down' },
    ],
    chart: {
      type: 'pie',
      title: 'Procurement Spend by Category',
      data: [
        { name: 'Structural Steel', value: 32 },
        { name: 'MEP Equipment', value: 24 },
        { name: 'Facade Materials', value: 21 },
        { name: 'Finishes', value: 14 },
        { name: 'Other', value: 9 },
      ],
    },
    insight: "Structural steel lead times have extended by 1.2 weeks industry-wide — recommend locking in Q3 orders early to protect River Valley Tower's schedule.",
  },

  'Safety & Compliance': {
    kpis: [
      { label: 'Total Recordable Incident Rate', value: '0.8', delta: '', tone: 'up' },
      { label: 'Days Since Last LTI', value: '64', delta: '', tone: 'up' },
      { label: 'Compliance Audits Passed', value: '12 / 12', delta: '', tone: 'flat' },
    ],
    chart: {
      type: 'bar',
      title: 'Near-Miss Reports by Site',
      data: [
        { name: 'Marina Bay Residences', value: 4 },
        { name: 'Orchard Heights', value: 2 },
        { name: 'River Valley Tower', value: 7 },
        { name: 'Tampines Central Mall', value: 3 },
        { name: 'Sentosa Cove Villas', value: 1 },
      ],
      series: [{ dataKey: 'value', name: 'Near-Miss Reports', color: '#EC4899' }],
      xKey: 'name',
    },
    insight: "River Valley Tower's elevated near-miss count is linked to congested laydown areas — additional site logistics planning is recommended.",
  },

  'Retail Sales & Foot Traffic': {
    kpis: [
      { label: 'Monthly Footfall', value: '412,000', delta: '+6.4%', tone: 'up' },
      { label: 'Avg. Basket Size', value: '$86', delta: '+2.4%', tone: 'up' },
      { label: 'Conversion Rate', value: '24%', delta: '', tone: 'flat' },
    ],
    chart: {
      type: 'line',
      title: 'Footfall Trend — Tampines Central Mall',
      data: [
        { name: 'Jan', value: 355000 },
        { name: 'Feb', value: 368000 },
        { name: 'Mar', value: 372000 },
        { name: 'Apr', value: 390000 },
        { name: 'May', value: 401000 },
        { name: 'Jun', value: 412000 },
      ],
      series: [{ dataKey: 'value', name: 'Footfall', color: '#22C55E' }],
      xKey: 'name',
    },
    insight: 'Footfall has grown for 6 consecutive months at Tampines Central Mall, with weekend traffic up 18% following the F&B tenant refresh.',
  },

  'Tenant / Leasing Data': {
    kpis: [
      { label: 'Portfolio Occupancy', value: '93.5%', delta: '+1.1pt', tone: 'up' },
      { label: 'WALE', value: '4.2 yrs', delta: '', tone: 'flat' },
      { label: 'Avg. Rent', value: '$14.80 psf', delta: '+3.2%', tone: 'up' },
    ],
    chart: {
      type: 'bar',
      title: 'Occupancy % by Project',
      data: [
        { name: 'Marina Bay Residences', value: 96 },
        { name: 'Orchard Heights', value: 91 },
        { name: 'River Valley Tower', value: 88 },
        { name: 'Tampines Central Mall', value: 95 },
        { name: 'Sentosa Cove Villas', value: 97 },
      ],
      series: [{ dataKey: 'value', name: 'Occupancy %', color: '#7C3AED' }],
      xKey: 'name',
    },
    insight: "River Valley Tower's occupancy sits below the portfolio average — 3 units are in active lease negotiation, expected to close within Q3.",
  },

  'Access & Movement Analytics': {
    kpis: [
      { label: 'Peak Hour Entries', value: '3,420', delta: '', tone: 'flat' },
      { label: 'Avg. Dwell Time', value: '48 min', delta: '', tone: 'flat' },
      { label: 'Elevator Wait (Peak)', value: '42 sec', delta: '+6s', tone: 'down' },
    ],
    chart: {
      type: 'line',
      title: 'Hourly Entries (10am – 8pm)',
      data: [
        { name: '10a', value: 320 },
        { name: '11a', value: 480 },
        { name: '12p', value: 610 },
        { name: '1p', value: 540 },
        { name: '2p', value: 780 },
        { name: '3p', value: 920 },
        { name: '5p', value: 1050 },
        { name: '6p', value: 880 },
        { name: '7p', value: 650 },
        { name: '8p', value: 410 },
      ],
      series: [{ dataKey: 'value', name: 'Entries', color: '#06B6D4' }],
      xKey: 'name',
    },
    insight: 'Peak congestion occurs between 5–6pm; recommend dynamic elevator dispatch tuning to bring average wait back below the 40-second target.',
  },

  'Energy & Building Systems': {
    kpis: [
      { label: 'Building EUI', value: '104 kWh/m²/yr', delta: '-16.5%', tone: 'up' },
      { label: 'HVAC Uptime', value: '99.2%', delta: '', tone: 'flat' },
      { label: 'Energy Cost Savings (YTD)', value: '$186K', delta: '', tone: 'up' },
    ],
    chart: {
      type: 'line',
      title: 'Monthly Energy Consumption (kWh)',
      data: [
        { name: 'Jan', value: 182000 },
        { name: 'Feb', value: 175000 },
        { name: 'Mar', value: 168000 },
        { name: 'Apr', value: 171000 },
        { name: 'May', value: 159000 },
        { name: 'Jun', value: 152000 },
      ],
      series: [{ dataKey: 'value', name: 'kWh', color: '#F97316' }],
      xKey: 'name',
    },
    insight: 'Consumption has fallen 16.5% since the chiller plant optimization rollout in month 2 — on pace to exceed the annual $200K savings target.',
  },

  'Asset Performance & Financial': {
    kpis: [
      { label: 'Annual NOI', value: '$28.4M', delta: '+7.2%', tone: 'up' },
      { label: 'Cap Rate', value: '4.6%', delta: '', tone: 'flat' },
      { label: 'NOI Growth (YoY)', value: '+7.2%', delta: '', tone: 'up' },
    ],
    chart: {
      type: 'line',
      title: 'NOI Trend, 5-Year ($M)',
      data: [
        { name: 'Y1', value: 21.2 },
        { name: 'Y2', value: 23.5 },
        { name: 'Y3', value: 24.8 },
        { name: 'Y4', value: 26.6 },
        { name: 'Y5', value: 28.4 },
      ],
      series: [{ dataKey: 'value', name: 'NOI ($M)', color: '#22C55E' }],
      xKey: 'name',
    },
    insight: "NOI has grown for 5 consecutive years; Sentosa Cove Villas and Tampines Central Mall are this year's top two contributors to that growth.",
  },

  'Maintenance & Lifecycle': {
    kpis: [
      { label: 'Open Work Orders', value: '34', delta: '', tone: 'flat' },
      { label: 'Avg. Resolution Time', value: '2.1 days', delta: '', tone: 'up' },
      { label: 'Preventive vs Reactive', value: '72% / 28%', delta: '', tone: 'flat' },
    ],
    chart: {
      type: 'bar',
      title: 'Work Orders by Building System',
      data: [
        { name: 'HVAC', value: 38 },
        { name: 'Electrical', value: 22 },
        { name: 'Plumbing', value: 18 },
        { name: 'Facade', value: 12 },
        { name: 'Other', value: 10 },
      ],
      series: [{ dataKey: 'value', name: '% of Work Orders', color: '#7C3AED' }],
      xKey: 'name',
    },
    insight: 'HVAC accounts for over a third of work orders — a condition-based maintenance pilot is recommended ahead of the next capex cycle.',
  },

  'ESG & Sustainability': {
    kpis: [
      { label: 'Portfolio GHG Intensity', value: '32 kgCO2e/m²', delta: '-9%', tone: 'up' },
      { label: 'Water Use Reduction', value: '14%', delta: '', tone: 'up' },
      { label: 'Green Certified Assets', value: '4 / 5', delta: '', tone: 'flat' },
    ],
    chart: {
      type: 'bar',
      title: 'GHG Intensity by Project (kgCO2e/m²)',
      data: [
        { name: 'Marina Bay Residences', value: 29 },
        { name: 'Orchard Heights', value: 26 },
        { name: 'River Valley Tower', value: 41 },
        { name: 'Tampines Central Mall', value: 33 },
        { name: 'Sentosa Cove Villas', value: 24 },
      ],
      series: [{ dataKey: 'value', name: 'kgCO2e/m²', color: '#F97316' }],
      xKey: 'name',
    },
    insight: "River Valley Tower is the portfolio's highest emissions-intensity asset — prioritised for the next retrofit and renewable energy procurement cycle.",
  },

  'Benchmarking & Market Research': {
    kpis: [
      { label: 'Cap Rate vs Market', value: '-30 bps', delta: 'outperforming', tone: 'up' },
      { label: 'Rent Premium vs Comp Set', value: '+6.8%', delta: '', tone: 'up' },
      { label: 'Market Reports Tracked', value: '14', delta: '', tone: 'flat' },
    ],
    chart: {
      type: 'bar',
      title: 'Rent psf — Portfolio vs Market Comp Set',
      data: [
        { name: 'Portfolio', value: 14.8 },
        { name: 'Market Comp Set', value: 13.85 },
      ],
      series: [{ dataKey: 'value', name: 'Rent ($ psf)', color: '#06B6D4' }],
      xKey: 'name',
    },
    insight: 'The portfolio commands a 6.8% rent premium over the comparable set, driven by amenity differentiation at Marina Bay Residences and Sentosa Cove Villas.',
  },
};

export default categoryData;
